/** Shared locale formatting for admin UI. */

export const resolveFirestoreDate = (value: unknown): Date | undefined => {
  if (value == null) return undefined;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? undefined : value;
  }
  if (typeof value === 'object') {
    const record = value as { toDate?: () => Date; seconds?: number };
    if (typeof record.toDate === 'function') {
      const parsed = record.toDate();
      return parsed instanceof Date && !Number.isNaN(parsed.getTime())
        ? parsed
        : undefined;
    }
    if (typeof record.seconds === 'number') {
      const parsed = new Date(record.seconds * 1000);
      return Number.isNaN(parsed.getTime()) ? undefined : parsed;
    }
  }
  if (typeof value === 'string' || typeof value === 'number') {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  }
  return undefined;
};

export const formatDateEsFromFirestore = (value: unknown): string => {
  const parsed = resolveFirestoreDate(value);
  return parsed ? formatDateEs(parsed) : '—';
};

export const formatDateTimeEsFromFirestore = (value: unknown): string => {
  const parsed = resolveFirestoreDate(value);
  return parsed ? formatDateTimeEs(parsed) : '—';
};

export const formatMoney = (value: number, currency = 'USD'): string => {
  try {
    return new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
    }).format(Number(value || 0));
  } catch {
    return `${Number(value || 0).toFixed(2)} ${currency}`;
  }
};

export const formatDateEs = (value?: string | Date): string => {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return new Intl.DateTimeFormat('es-VE', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(parsed);
};

export const formatDateTimeEs = (value?: string | Date): string => {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return new Intl.DateTimeFormat('es-VE', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(parsed);
};

export const formatTimeEs = (value?: string | Date): string => {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return new Intl.DateTimeFormat('es-VE', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(parsed);
};

export const formatTimeEsFromFirestore = (value: unknown): string => {
  const parsed = resolveFirestoreDate(value);
  return parsed ? formatTimeEs(parsed) : '—';
};
